import qs from 'query-string'

/* eslint-disable @typescript-eslint/no-unused-vars */
type UpdateQueryStringFilters = Record<string, string | string[]> & {
  children: number[][]
  boxShape?: {
    topLeft: {
      latitude: number
      longitude: number
    }
    bottomRight: {
      latitude: number
      longitude: number
    }
  }
}

export function updateQueryStringFilters(filters: UpdateQueryStringFilters, base?: string) {
  const currentQueryString = base || window?.location.search || ''
  const currentParams = qs.parse(currentQueryString)
  // Remove from query unwanted previous filters
  const {
    stars,
    family,
    orderBy,
    facilities,
    accommodationTypes,
    ratings,
    maxPrice,
    minPrice,
    page,
    highlightedProperty,
    city: cityQuery,
    term: termQuery,
    filters: filtersObjQuery,
    longitude: lonQuery,
    latitude: latQuery,
    slug: slugQuery,
    type: typeQuery,
    ...restOldFilters
  } = currentParams

  // Remove from query unwanted new filters
  const {
    city,
    longitude,
    latitude,
    slug,
    type,
    page: pageNew,
    filters: filtersObj,
    ...restNewFilters
  } = filters

  // Stringify children array: [[1,2], [3,4]] => '1,2!3,4' (! separated rooms, comma separated ages in each room)
  const children = filters.children?.map(child => child.join(',')).join('!')

  const coordinates = JSON.stringify(restNewFilters.coordinates)
  const boxShape = JSON.stringify(restNewFilters.boxShape)

  let pageNewInteger = Number(pageNew)

  if (Number.isNaN(pageNewInteger)) {
    pageNewInteger = 1
  }

  return qs.stringify(
    { ...restOldFilters, ...restNewFilters, children, coordinates, boxShape, page: pageNewInteger },
    { arrayFormat: 'comma', skipEmptyString: true, skipNull: true }
  )
}

interface UpdateQueryStringHighlighted {
  highlightedProperty: string | string[]
  aid: string | string[]
  source: string | string[]
  total?: string | string[]
  subtotal?: string | string[]
  taxes?: string | string[]
  // eslint-disable-next-line camelcase
  internal_navigation?: string | string[]
  // eslint-disable-next-line camelcase
  feature_flag?: string | string[]
}

export function updateQueryStringHighlighted({
  highlightedProperty,
  aid,
  source,
  total,
  subtotal,
  taxes,
  // eslint-disable-next-line camelcase
  internal_navigation,
  // eslint-disable-next-line camelcase
  feature_flag,
}: UpdateQueryStringHighlighted) {
  return qs.stringify(
    // eslint-disable-next-line camelcase
    { highlightedProperty, aid, source, total, subtotal, taxes, internal_navigation, feature_flag },
    { arrayFormat: 'comma', skipEmptyString: true, skipNull: true }
  )
}
